import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LegalPage.css';

export default function GdprPage() {
  const navigate = useNavigate();

  return (
    <div className="legal-root">
      <header className="legal-header">
        <button className="legal-back" onClick={() => navigate('/')}>← Επιστροφή</button>
        <div className="legal-logo">✂ SalonBook</div>
      </header>

      <div className="legal-content">
        <div className="legal-hero">
          <div className="legal-badge">Νομικά</div>
          <h1>Συμμόρφωση GDPR</h1>
          <p>Τελευταία ενημέρωση: Μάιος 2026</p>
        </div>

        <div className="legal-body">

          <section className="legal-highlight">
            <h2>🔒 Η δέσμευσή μας</h2>
            <p>Η SalonBook συμμορφώνεται πλήρως με τον Γενικό Κανονισμό Προστασίας Δεδομένων (GDPR) — Κανονισμός (ΕΕ) 2016/679. Η προστασία των προσωπικών δεδομένων είναι θεμελιώδης αρχή μας.</p>
          </section>

          <section>
            <h2>1. Υπεύθυνος Επεξεργασίας</h2>
            <p>Υπεύθυνος επεξεργασίας των δεδομένων σας είναι:</p>
            <ul>
              <li><strong>Εταιρεία:</strong> SalonBook</li>
              <li><strong>Έδρα:</strong> Αθήνα, Ελλάδα</li>
              <li><strong>Email DPO:</strong> <a href="mailto:dpo@salonbook.gr">dpo@salonbook.gr</a></li>
            </ul>
          </section>

          <section>
            <h2>2. Κατηγορίες δεδομένων</h2>
            <div className="legal-table">
              <div className="legal-table-row legal-table-header">
                <span>Κατηγορία</span>
                <span>Σκοπός</span>
                <span>Βάση</span>
                <span>Διατήρηση</span>
              </div>
              <div className="legal-table-row">
                <span>Στοιχεία λογαριασμού</span>
                <span>Παροχή υπηρεσίας</span>
                <span>Σύμβαση</span>
                <span>Διάρκεια συνδρομής + 30 ημέρες</span>
              </div>
              <div className="legal-table-row">
                <span>Δεδομένα πελατών</span>
                <span>Κρατήσεις</span>
                <span>Σύμβαση</span>
                <span>5 χρόνια</span>
              </div>
              <div className="legal-table-row">
                <span>Logs συστήματος</span>
                <span>Ασφάλεια</span>
                <span>Νόμιμο συμφέρον</span>
                <span>90 ημέρες</span>
              </div>
            </div>
          </section>

          <section>
            <h2>3. Τα δικαιώματά σας</h2>
            <div className="legal-rights">
              <div className="legal-right">
                <div className="legal-right-icon">👁</div>
                <div>
                  <h4>Δικαίωμα Πρόσβασης</h4>
                  <p>Μπορείτε να ζητήσετε αντίγραφο όλων των δεδομένων που διατηρούμε για εσάς.</p>
                </div>
              </div>
              <div className="legal-right">
                <div className="legal-right-icon">✏️</div>
                <div>
                  <h4>Δικαίωμα Διόρθωσης</h4>
                  <p>Μπορείτε να ζητήσετε διόρθωση ανακριβών ή ελλιπών δεδομένων.</p>
                </div>
              </div>
              <div className="legal-right">
                <div className="legal-right-icon">🗑️</div>
                <div>
                  <h4>Δικαίωμα Διαγραφής</h4>
                  <p>Μπορείτε να ζητήσετε τη διαγραφή των δεδομένων σας («δικαίωμα στη λήθη»).</p>
                </div>
              </div>
              <div className="legal-right">
                <div className="legal-right-icon">⏸</div>
                <div>
                  <h4>Δικαίωμα Περιορισμού</h4>
                  <p>Μπορείτε να ζητήσετε περιορισμό της επεξεργασίας υπό ορισμένες συνθήκες.</p>
                </div>
              </div>
              <div className="legal-right">
                <div className="legal-right-icon">📦</div>
                <div>
                  <h4>Δικαίωμα Φορητότητας</h4>
                  <p>Μπορείτε να λάβετε τα δεδομένα σας σε μηχαναγνώσιμη μορφή (JSON/CSV).</p>
                </div>
              </div>
              <div className="legal-right">
                <div className="legal-right-icon">🚫</div>
                <div>
                  <h4>Δικαίωμα Εναντίωσης</h4>
                  <p>Μπορείτε να αντιταχθείτε στην επεξεργασία για σκοπούς νόμιμου συμφέροντος.</p>
                </div>
              </div>
            </div>
          </section>

          <section>
            <h2>4. Διαβίβαση εκτός ΕΕ</h2>
            <p>Τα δεδομένα σας αποθηκεύονται σε servers εντός της ΕΕ. Σε περίπτωση διαβίβασης εκτός ΕΕ, εφαρμόζουμε κατάλληλες εγγυήσεις (Τυποποιημένες Συμβατικές Ρήτρες).</p>
          </section>

          <section>
            <h2>5. Ασφάλεια δεδομένων</h2>
            <ul>
              <li>✅ Κρυπτογράφηση δεδομένων σε transit (TLS 1.3)</li>
              <li>✅ Κρυπτογράφηση δεδομένων at rest</li>
              <li>✅ Έλεγχος πρόσβασης βάσει ρόλων (RBAC)</li>
              <li>✅ Τακτικά αντίγραφα ασφαλείας</li>
              <li>✅ Monitoring και alerts ασφαλείας</li>
              <li>✅ Τακτικοί έλεγχοι ασφαλείας</li>
            </ul>
          </section>

          <section>
            <h2>6. Παραβίαση δεδομένων</h2>
            <p>Σε περίπτωση παραβίασης δεδομένων που ενδέχεται να θέσει σε κίνδυνο τα δικαιώματά σας:</p>
            <ul>
              <li>Θα ειδοποιήσουμε την ΑΠΔΠΧ εντός 72 ωρών</li>
              <li>Θα σας ειδοποιήσουμε άμεσα αν υπάρχει υψηλός κίνδυνος</li>
            </ul>
          </section>

          <section>
            <h2>7. Άσκηση δικαιωμάτων</h2>
            <p>Για να ασκήσετε οποιοδήποτε από τα δικαιώματά σας:</p>
            <ul>
              <li>📧 Email: <a href="mailto:dpo@salonbook.gr">dpo@salonbook.gr</a></li>
              <li>⏱ Απάντηση εντός 30 ημερών</li>
              <li>🆓 Δωρεάν (εκτός υπερβολικά επαναλαμβανόμενων αιτημάτων)</li>
            </ul>
            <p>Έχετε επίσης δικαίωμα καταγγελίας στην <a href="https://www.dpa.gr" target="_blank" rel="noopener noreferrer">ΑΠΔΠΧ (www.dpa.gr)</a>.</p>
          </section>

        </div>
      </div>

      <footer className="legal-footer">
        <span>© {new Date().getFullYear()} SalonBook. Όλα τα δικαιώματα διατηρούνται.</span>
        <div className="legal-footer-links">
          <a href="/privacy">Πολιτική Απορρήτου</a>
          <a href="/terms">Όροι Χρήσης</a>
          <a href="/gdpr">GDPR</a>
        </div>
      </footer>
    </div>
  );
}